import { render } from "./ActiveTray.vue?vue&type=template&id=4e9870ea"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ActiveTray.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e9870ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e9870ea', __exports__)) {
    api.reload('4e9870ea', __exports__)
  }
  
  module.hot.accept("./ActiveTray.vue?vue&type=template&id=4e9870ea", () => {
    api.rerender('4e9870ea', render)
  })

}


export default __exports__